// cartForm
export const ADD_GUEST_PASS = 'ADD_GUEST_PASS'
export const REMOVE_GUEST_PASS = 'REMOVE_GUEST_PASS'
export const RESET_CART_FORM = 'RESET_CART_FORM'
export const SET_CART_LOCATION = 'SET_CART_LOCATION'
export const SET_CART_PRODUCT = 'SET_CART_PRODUCT'
export const SET_CART_PRODUCT_DEFAULT = 'SET_CART_PRODUCT_DEFAULT'
export const SET_CART_DAYS = 'SET_CART_DAYS'
export const SET_CART_DATE = 'SET_CART_DATE'
export const SET_CART_ACKNOWLEDGED_SOFT_CLOSE =
  'SET_CART_ACKNOWLEDGED_SOFT_CLOSE'
